export default __webpack_public_path__ + "static/media/leftArrowSecondary.62bac898.svg";